import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Grid, Drawer, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
const styles = {
  list: {
    width: "20rem",
    padding: "1.5rem"
  },
  button: {
    width: "100%"
  }
};
class FilterList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDrawer: this.props.openDrawer || false
    };
  }
  componentDidMount = () => {
    this.props.onRef(this);
  };
  toggleDrawer = (open, event) => {
    if (
      event &&
      (event.type === "keydown" ||
        event.type === "Tab" ||
        event.type === "Shift")
    ) {
      return;
    }

    if (open != this.state.openDrawer) this.setState({ openDrawer: open });
  };
  action = action => {
    let { clearFilter, getList } = this.props;
    if (action === "clearFilter") clearFilter();
    else if (action === "getList") getList();
    this.toggleDrawer(false);
  };
  render() {
    const { classes } = this.props;
    const {
      children = "",
      className = "",
      side = "",
      getList,
      clearFilter,
      t,
      ...props
    } = this.props;
    const sideList = () => (
      <div
        className={classes.list}
        role="presentation"
        // onClick={this.toggleDrawer(side, false)}
        onKeyDown={e => this.toggleDrawer(false, e)}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Button onClick={e => this.toggleDrawer(false, e)}>
              <CloseIcon />
              {t("customer_listcustomer_close")}
            </Button>
          </Grid>
          {children}
          <Grid item sm={12}>
            <Button
              className={classes.button}
              variant="contained"
              color="default"
              onClick={() => this.action("clearFilter")}
            >
              {t("customer_listcustomer_clear")}
            </Button>
          </Grid>
          <Grid item sm={12}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={() => this.action("getList")}
            >
              {t("customer_listcustomer_apply_filter")}
            </Button>
          </Grid>
        </Grid>
      </div>
    );
    return (
      <Drawer
        anchor="right"
        open={this.state.openDrawer}
        onClose={e => this.toggleDrawer(false, e)}
      >
        {sideList("openDrawer")}
      </Drawer>
    );
  }
}

FilterList.propTypes = {
  // onChange: PropTypes.func.isRequired,
};

const mapState = state => ({});

const mapDispatch = dispatch => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(FilterList)));
